<template>
  <div class="addActivity">
    <transition name="slideFromLeft">
      <button v-if="!addOpen" @click="addNew">Add Activity</button>
    </transition>
    <transition name="slideFromRight">
      <div v-if="addOpen">
        <form @submit.prevent="add" class="addActivityForm">
          <input ref="activityName" name="activityName" v-model="input.activityName" />
          <button type="submit">Add</button>
          <a href="#" @click="cancelAdd">Cancel</a>
        </form>
      </div>
    </transition>
  </div>
</template>

<style scoped>
  a {font-size: 10px;}
</style>

<script>
import DataActivities from '@/data/controllers/DataActivities'

export default {
  name: 'addActivity',
  data () {
    return {
      addOpen: false,
      input: {
        activityName: ''
      }
    }
  },
  methods: {
    addNew () {
      this.addOpen = !this.addOpen
      let $this = this
      this.$nextTick(function () {
        $this.$refs.activityName.focus()
      })
    },
    add () {
      if (this.input.activityName === '') {
        alert('Name is required')
        this.$refs.activityName.focus()
        return
      }

      DataActivities.addActivity(this.input.activityName)
      this.input.activityName = ''
      this.addOpen = !this.addOpen
      /*
      let params = {'api_token': store.state.key, 'title': this.input.activityName}
      let $this = this
      this.$axios.post(process.env.API_BASE + 'api/activities/add', params)
        .then(
          (response) => {
            let { data } = response
            store.commit('addActivity', {
              activity: data
            })
            this.input.activityName = ''
            this.addOpen = !this.addOpen
          },
          (error) => {
            if (error.message === 'Request failed with status code 400') {
              let message = this.input.activityName + ' is already in use'
              alert(message)
            } else {
              alert('problem processing!')
            }
            $this.formError = true
          }
        )
        */
    },
    cancelAdd () {
      this.addOpen = !this.addOpen
    }
  }
}

</script>

<style lang="scss">
  .addActivityForm {
    display: flex;
    align-items: center;
    justify-content: center;
    // column-gap: 10px;
    > * {
      margin: 0 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/activities/AddActivity.vue